module.exports = __webpack_public_path__ + "fonts/nunitosans-bold-webfont.c1fef98.woff2";